import { FC, useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import clsx from 'clsx'

import OfferAggre from 'components/parts/offer-aggre/offer-aggre'
import Button from 'components/parts/button/button'
import ButtonThemes from 'components/parts/button/themes'
import WidgetYaPay from 'components/parts/widget-ya-pay/widget-ya-pay'
import InputValidation from 'components/form-parts/input-validation/input-validation'
import PopupWrapper from 'containers/popup-wrapper/popup-wrapper'
import PriceBlock from 'components/parts/price-block/price-block'
import ButtonToPayment from 'components/parts/button-to-payment/button-to-payment'
import ScrollArea from 'containers/scroll-area/scroll-area'
import Auth from 'store/auth'

import WidgetYaPayThemes from 'components/parts/widget-ya-pay/data'
import { ICourseType } from 'constants/types/course.types'
import { BASE_URL } from 'constants/url'
import { postAxiosSingle } from 'pages/api/axios'
import { currSeminarData } from 'constants/data'
import { applyPromocode, letterImage, iconData, nameForOffer } from './data'
import { cutHashFromURL } from 'utils/getURLData'
import { OfferType } from 'components/parts/offer-aggre/data'
import { ConsultationType, PurchaseType } from 'constants/types/consultation.types'
import { PAYMENT_POPUP_QUERY } from 'components/course/unpaid-course/purchase/data'

import style from './popup-buy-course.module.scss'
interface IPopupBuyCourse {
  courseInfo: ICourseType
  paymentPopup: string
  handleShowPopup?: (val: boolean) => void
}

const PopupBuyCourse: FC<IPopupBuyCourse> = ({ courseInfo, handleShowPopup, paymentPopup }) => {
  const { name, newPrice, price, percentage, id } = courseInfo
  const { innerWidth } = window
  const { userProfile } = Auth.useAuth()

  const popupValue = paymentPopup ? Number(paymentPopup) : 1

  const router = useRouter()
  const path = cutHashFromURL(router.asPath)
  const isTrial = path.includes('trial')

  const [letterSend, setLetterSend] = useState(false)
  const [promocode, setPromocode] = useState({
    code: '',
    applied: false,
    newPrice: newPrice || price,
    percentage: percentage || '',
    discount: false,
    status: '',
  })

  const PaymentData = useMemo(
    () => ({
      returnUrl: `${currSeminarData.domain}/order`,
      description: 'Покупка программы дополнительного профессионального образования',
      materialType: 'course',
      amount: Number(newPrice || price) * 100,
      materialId: id,
    }),
    [id, newPrice, price]
  )
  const [extendedPaymentData, setExtendedPaymentData] = useState<any>(PaymentData)

  const closePopup = () => {
    handleShowPopup && handleShowPopup(false)
  }

  const closeLetterMessage = () => {
    handleShowPopup && handleShowPopup(false)
    setLetterSend(false)
  }

  const promocodeChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (event) =>
    setPromocode((prevValue) => ({ ...prevValue, code: event.target.value, applied: false }))

  const applyPromocodeHandler = (e: any) => {
    applyPromocode(e, PaymentData, promocode, setPromocode, newPrice)
  }

  const submitAlfaHandler = async () => {
    setTimeout(
      () =>
        router.push(
          {
            pathname: '/process',
            query: {
              ...extendedPaymentData,
              email: userProfile.email,
              path,
              paymentService: 'alfa',
            },
          },
          '/process'
        ),
      500
    )
  }
  const changePayment = (paymentVariant: number | string) => {
    router.push({ query: { ...router.query, [PAYMENT_POPUP_QUERY]: paymentVariant } }, undefined, {
      shallow: false,
    })
  }

  const handleConsultation = async (userInfo: any) => {
    const res = await postAxiosSingle(
      `${BASE_URL.NMO_COURSE}/consultation`,
      {},
      {
        email: userInfo.email,
        fullName: `${userInfo.firstName} ${userInfo.lastName} ${userInfo.secondName}`.trim(),
        phone: userInfo.phone,
        courseId: id,
        reason: isTrial ? 'trial' : 'program',
        typePurchase: Number(paymentPopup) === 3 ? PurchaseType.EMPLOYER : PurchaseType.EMPLOYER,
        type: ConsultationType.PURCHASE,
        path,
      }
    )
    if (res.status !== 200 && res.status !== 201) {
      console.log('Ошибка отправки консультации')
    }
    setLetterSend(true)
  }

  useEffect(() => {
    // Тайммаут - опять же для яндекса, иногда виджет пропадает, если его убрать
    setTimeout(() => {
      setExtendedPaymentData({
        ...PaymentData,
        email: userProfile.email,
        amount: Number(promocode.newPrice) * 100,
        promocode: promocode.applied ? promocode.code : '',
      })
    }, 0)
  }, [PaymentData, promocode.discount, promocode.applied, userProfile])

  useEffect(() => {
    changePayment(popupValue)
  }, [])

  if (letterSend) {
    return (
      <PopupWrapper
        handlePopup={closeLetterMessage}
        isFullScreen={innerWidth <= 768 ? true : false}
        popupBlockModificator={style.popupEndModificator}
      >
        <div className={style.letterWrapper}>
          <div>
            <Image {...letterImage}></Image>
            <div className={style.letterTitle}>Заявка принята</div>
            <div className={style.subTitle}>
              В ближайшее время мы направим всю необходимую информацию вам на почту
            </div>
          </div>
          <div className={style.btnLetter}>
            <Button theme={ButtonThemes.SECOND} onClick={closeLetterMessage}>
              Хорошо, спасибо
            </Button>
          </div>
        </div>
      </PopupWrapper>
    )
  }

  return (
    <PopupWrapper
      handlePopup={closePopup}
      popupBlockModificator={style.popupModificator}
      isFullScreen={innerWidth <= 991 ? true : false}
    >
      <div className={clsx(style.firstBlock, style.commonPadding)}>
        <div className={style.step1}>
          <span>1</span>Способ оплаты
        </div>
        <div className={style.step2}>
          <span>2</span>Оплата
        </div>
      </div>
      <div className={style.scrollHelper}>
        <ScrollArea modificator={style.scrollWrap}>
          <div className={clsx(style.secondBlock, style.commonPadding)}>
            <div className={style.name}>Оплата курса “{name}”</div>
            <PriceBlock
              price={price}
              newPrice={promocode.newPrice}
              percentage={promocode.percentage}
              wrapperModificator={style.priceMod}
            />
            <InputValidation
              nameInput="Промокод"
              type="text"
              placeholder="Введите промокод"
              onChange={promocodeChangeHandler}
              value={promocode.code}
              touched={promocode.applied}
              error={promocode.discount ? '' : promocode.status}
              inputNameModificator={style.inputNameModificator}
            >
              {promocode.code && (
                <div className={style.promocodeApply} onClick={applyPromocodeHandler}>
                  Применить
                </div>
              )}
            </InputValidation>
            <div className={style.promoSub}>
              {promocode.applied && promocode.code
                ? 'Промокод применен'
                : 'Если у вас есть промокод на скидку, введите его в это поле'}
            </div>
          </div>

          <div className={style.commonPadding}>
            <div className={style.variantTitle}>Способы оплаты</div>

            <div className={style.paymentVariants}>
              {iconData.map((variant, index) => {
                return (
                  <div
                    className={clsx(style.variant, {
                      [style.activeVariant]: popupValue === index + 1,
                    })}
                    key={index}
                    onClick={() => {
                      changePayment(index + 1)
                    }}
                  >
                    <Image {...variant.imgData}></Image>
                    <div className={style.variantTxt}>{variant.txt}</div>
                  </div>
                )
              })}
            </div>
            {/* Не написано при помощи "Условного рендера" , тк возникает проблема с рендером виджета Яндекса - пока хз, как это нормально сдлеать */}
            <div
              className={clsx(style.btnPayment, {
                [style.state1]: popupValue <= 1 || !popupValue,
                [style.state2]: popupValue === 2,
                [style.state3]: popupValue === 3,
                [style.state4]: popupValue === 4,
              })}
            >
              <div className={style.dopInfoBtn}>
                <div className={clsx(style.btnTopTxt, style.txtCenter)}>
                  Доступ к курсу откроется сразу же после оплаты.
                </div>
                <ButtonToPayment
                  PaymentData={extendedPaymentData}
                  paymentHandler={submitAlfaHandler}
                  isButtonDisabled={Boolean(popupValue === 0 || !popupValue)}
                  text="Перейти к оплате"
                />
              </div>

              <div>
                <WidgetYaPay
                  isButtonDisabled={false}
                  PaymentData={extendedPaymentData}
                  mode={WidgetYaPayThemes.SPLIT}
                  emaileValue={userProfile.email}
                  onPayButtonClickHandler={() => null}
                />
              </div>
              <div className={style.dopInfoBtn}>
                <div className={style.btnTopTxt}>
                  При оплате за счет работодателя мы свяжемся с вами, уточним подробности и выставим
                  счёт на оплату от юридического лица
                </div>
                <Button
                  onClick={() => {
                    handleConsultation(userProfile)
                  }}
                >
                  Подать заявку
                </Button>
              </div>
            </div>

            <OfferAggre
              themeOffer={OfferType.DARK}
              btnName={nameForOffer[popupValue - 1] || nameForOffer[0]}
            />
          </div>
        </ScrollArea>
      </div>
    </PopupWrapper>
  )
}

export default PopupBuyCourse
